import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { SimpleModal, Icon } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import { ModalForm } from './modalForm';
export const UpdateUtilityCredentialsBatchModal = observer(_ref => {
  let credentialData = _ref.credentialData,
    customTrigger = _ref.customTrigger,
    showModal = _ref.showModal,
    handleShowModal = _ref.handleShowModal,
    propertyData = _ref.propertyData,
    portfolioData = _ref.portfolioData;
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    // triggerRefresh && triggerRefresh();
  };
  useEffect(() => {
    if (showModal && handleShowModal) {
      setIsModalOpen(true);
      handleShowModal(false, propertyData, portfolioData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  // NOTE: MockedData to remove when implement
  const credentialDataMock = [{
    id: '1231wqeq',
    utilityTypeName: 'Water',
    utilityProviderName: 'San Jose Water Company',
    propertyAddress: '7 Green Rd., Santa Monica, 90402',
    credentialIssueType: 'Wrong credential',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    utilityTypeName: 'Water',
    utilityProviderName: 'San Jose Water Company',
    propertyAddress: '7 Green Rd., Santa Monica, 90402',
    credentialIssueType: 'Credential expired',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    utilityTypeName: 'Water',
    utilityProviderName: 'San Jose Water Company',
    propertyAddress: '7 Green Rd., Santa Monica, 90402',
    credentialIssueType: 'Wrong security question',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com'
    // questions: [
    //   { questionName: 'What was your favourite school teacher’s name?', answerName: 'Blabla1' },
    //   { questionName: 'What was your favourite school teacher’s name? 2', answerName: 'blablah2' },
    // ],
  }, {
    id: '1231wqeq',
    utilityTypeName: 'Water',
    utilityProviderName: 'San Jose Water Company',
    propertyAddress: '7 Green Rd., Santa Monica, 90402',
    credentialIssueType: 'Wrong username or password',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    utilityTypeName: 'Water',
    utilityProviderName: 'San Jose Water Company',
    propertyAddress: '7 Green Rd., Santa Monica, 90402',
    credentialIssueType: 'Wrong credential',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name? ',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    utilityTypeName: 'Water',
    utilityProviderName: 'San Jose Water Company',
    propertyAddress: '7 Green Rd., Santa Monica, 90402',
    credentialIssueType: 'Wrong credential',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }];
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    title: t('add_new_property_flow.auto_billing_setup'),
    subTitle: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress,
    trigger: customTrigger !== undefined ? customTrigger : /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      'custom-attribute': '415-update-utility-credentials-batch-modal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, t('add_new_property_flow.begin_activation'))),
    isOpen: isModalOpen,
    handleOpen: handleModalOpen,
    handleClose: handleModalClose
  }, /*#__PURE__*/React.createElement(ModalForm, {
    credentialData: credentialData || (propertyData !== undefined ? [credentialDataMock[0]] : credentialDataMock),
    isSingleAction: propertyData !== undefined
  }));
});